// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"644":"c54937bd","667":"22b1153d"}[chunkId] + ".chunk.js";
};